export default "__VITE_ASSET__Gap4Hn20__"